module.exports = __webpack_public_path__ + "static/media/farming.f599b110.svg";